// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3UttC","errorLogs":"styles_errorLogs__27I-G"};